import React from "react";
import {
  TwitterShareButton,
  TwitterIcon,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";

const ShareButtons = ({ lesson }) => {
  const { headline, article } = lesson;
  return (
    <>
      <div className={`container`}>
        <div className="row mt-4">
          <div className="mt-2 col">
            {/* <a
              target="_blank"
              rel="noreferrer"
              onClick
              href={article}
              className="btn btn-lg btn-primary"
            > */}
            <button
              onClick={() => window.open(article)}
              className="btn btn-lg btn-primary"
            >
              Learn More
            </button>
            {/* </a> */}
          </div>

          <div className={`col w-100 flex-grow-0`}>
            <TwitterShareButton url={headline}>
              <TwitterIcon round />
            </TwitterShareButton>
          </div>
          <div className={`col flex-grow-0`}>
            <WhatsappShareButton url={headline}>
              <WhatsappIcon round />
            </WhatsappShareButton>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShareButtons;
